'use strict';

/**
 * Sync heights of Nav Cards Per Row
 */
function syncNavCards() {
    var $subCatCardnav = $('.subcat-card-nav');

    if ($subCatCardnav.length > 0) {
        $subCatCardnav.find('.subcat-card').matchHeight();
    }
}

$(document).ready(function () {
    syncNavCards();
});

$(window).smartresize(function () {
    syncNavCards();
});
